import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component that automatically scrolls to the top of the page
 * whenever the route changes, on page refresh, or browser back/forward navigation.
 * This ensures users always start at the top when navigating to a new page.
 */
export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        // Scroll to top when pathname changes (includes back/forward navigation)
        window.scrollTo(0, 0);
    }, [pathname]);

    useEffect(() => {
        // Handle browser back/forward navigation
        const handlePopState = () => {
            window.scrollTo(0, 0);
        };

        // Handle page refresh and URL navigation
        const handleBeforeUnload = () => {
            // Scroll to top before page unloads (for refresh)
            window.scrollTo(0, 0);
        };

        // Handle page load (for refresh and direct URL navigation)
        const handleLoad = () => {
            window.scrollTo(0, 0);
        };

        // Listen for browser back/forward navigation
        window.addEventListener('popstate', handlePopState);

        // Listen for page refresh and URL navigation
        window.addEventListener('beforeunload', handleBeforeUnload);
        window.addEventListener('load', handleLoad);

        // Scroll to top immediately on mount (handles refresh)
        window.scrollTo(0, 0);

        // Cleanup listeners on unmount
        return () => {
            window.removeEventListener('popstate', handlePopState);
            window.removeEventListener('beforeunload', handleBeforeUnload);
            window.removeEventListener('load', handleLoad);
        };
    }, []);

    return null;
}
